import { DoqFaceSvgProps } from '../types';

const Broadcast = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 144 144"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1698_47325)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-broadcast">
        <circle cx="72" cy="72" r="72" fill="white" />
        <path d="M 108,135 A 72,72 0 0,1 36,135 L 72,72 Z" fill="black" />
      </mask>
      <circle
        cx="72"
        cy="72"
        r="72"
        fill="#C7C1C8"
        mask="url(#bottom-mask-broadcast)"
      />

      <mask
        id="mask0_1698_47325"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="144"
        height="144"
      >
        <circle cx="72" cy="72" r="72" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_47325)">
        <rect x="36" y="54" width="72" height="90" fill="white" />
      </g>

      <path
        d="M63.8998 82.8C65.888 82.8 67.4998 81.1882 67.4998 79.2C67.4998 77.2118 65.888 75.6 63.8998 75.6C61.9116 75.6 60.2998 77.2118 60.2998 79.2C60.2998 81.1882 61.9116 82.8 63.8998 82.8Z"
        fill="#2974C4"
      />
      <path
        d="M80.0998 82.8C82.088 82.8 83.6998 81.1882 83.6998 79.2C83.6998 77.2118 82.088 75.6 80.0998 75.6C78.1116 75.6 76.4998 77.2118 76.4998 79.2C76.4998 81.1882 78.1116 82.8 80.0998 82.8Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.8328 93.5976C72.3671 93.5632 72 93.1745 72 92.7C72 92.203 72.4029 91.8 72.9 91.8H79.425C80.2948 91.8 81 91.0949 81 90.225C81 90.1485 80.9945 90.0732 80.984 89.9996L81 89.9996C81.0002 89.5027 81.4031 89.1 81.9 89.1C82.3971 89.1 82.8 89.503 82.8 90C82.8 90.0263 82.7989 90.0524 82.7967 90.0781L82.7926 89.9997C82.7975 90.0742 82.8 90.1493 82.8 90.225C82.8 92.089 81.289 93.6 79.425 93.6H72.9L72.8328 93.5976Z"
        fill="#2974C4"
      />
      <path
        d="M67.4117 28.249C67.1215 27.9221 66.6512 27.9221 66.361 28.249C63.6336 31.3225 63.6336 36.3055 66.361 39.379C66.5476 39.5966 66.8238 39.6839 67.0836 39.6073C67.3434 39.5307 67.5463 39.3021 67.6143 39.0093C67.6823 38.7166 67.6048 38.4053 67.4117 38.1951C66.3802 37.0331 65.8007 35.4569 65.8007 33.8134C65.8007 32.1699 66.3802 30.5937 67.4117 29.4318C67.7011 29.1049 67.7011 28.5758 67.4117 28.249Z"
        fill="#D12E69"
      />
      <path
        d="M76.5972 28.2487C76.3079 28.5754 76.3079 29.1049 76.5972 29.4315C77.6257 30.5924 78.2036 32.167 78.2036 33.809C78.2036 35.4509 77.6257 37.0256 76.5972 38.1864C76.399 38.3951 76.3176 38.7092 76.3847 39.0055C76.4519 39.3018 76.657 39.5331 76.9195 39.6087C77.1821 39.6842 77.4602 39.592 77.6448 39.3681C80.3646 36.2975 80.3646 31.3193 77.6448 28.2487C77.3555 27.9222 76.8865 27.9222 76.5972 28.2487Z"
        fill="#D12E69"
      />
      <path
        d="M81.086 23.8768C81.3532 23.8017 81.6373 23.8872 81.8291 24.1004V24.0999C84.1795 26.6224 85.4999 30.0438 85.4999 33.6113C85.4999 37.1787 84.1795 40.6001 81.8291 43.1227C81.6373 43.3359 81.3532 43.4214 81.086 43.3463C80.8188 43.2713 80.6101 43.0473 80.5402 42.7606C80.4703 42.4738 80.5499 42.1689 80.7486 41.9629C85.0392 37.3579 85.0392 29.8652 80.7486 25.2602C80.5499 25.0542 80.4703 24.7493 80.5402 24.4625C80.6101 24.1758 80.8188 23.9518 81.086 23.8768Z"
        fill="#EF5D92"
      />
      <path
        d="M62.1778 24.0905C62.4768 23.7698 62.9615 23.7698 63.2604 24.0905C63.5593 24.4113 63.5593 24.9313 63.2604 25.252C58.9596 29.8642 58.9596 37.3689 63.2604 41.981C63.5506 42.3033 63.5465 42.8156 63.2511 43.1325C62.9558 43.4493 62.4782 43.4538 62.1778 43.1425C59.823 40.6161 58.5 37.1895 58.5 33.6165C58.5 30.0436 59.823 26.6169 62.1778 24.0905Z"
        fill="#EF5D92"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.5008 45.5683L79.1998 54H64.7998L70.1998 37.1307H73.7998L76.4565 45.43L76.5807 45.5091L76.5008 45.5683ZM70.6219 41.7163L71.5136 38.9307H72.486L74.0829 43.9192L70.6219 41.7163ZM67.5509 52.2H76.7336L74.9731 46.7003L67.5509 52.2ZM70.1636 43.5582L68.5649 49.2084L73.4054 45.6216L70.1636 43.5582Z"
        fill="#475362"
      />
      <path
        d="M72 37.8C74.2368 37.8 76.05 35.9868 76.05 33.75C76.05 31.5133 74.2368 29.7 72 29.7C69.7632 29.7 67.95 31.5133 67.95 33.75C67.95 35.9868 69.7632 37.8 72 37.8Z"
        fill="#141414"
      />
      <path
        d="M79.2591 50.6667C79.1735 50.5028 79.0039 50.4 78.819 50.4H65.181C64.9961 50.4 64.8265 50.5028 64.7409 50.6667L63 54H81L79.2591 50.6667Z"
        fill="#141414"
      />
      <path
        d="M71.9678 31.3852C73.3857 31.4871 74.4613 32.7052 74.387 34.1248L74.3535 34.7659C74.3405 35.0141 74.5312 35.2258 74.7793 35.2388C75.0275 35.2518 75.2393 35.0611 75.2522 34.8129L75.2858 34.1719C75.3857 32.2626 73.9392 30.6246 72.0323 30.4875L71.9678 31.3852Z"
        fill="white"
      />
      <g opacity="0.5">
        <path
          d="M66.6 120.6C66.6 121.594 65.7941 122.4 64.8 122.4C63.8059 122.4 63 121.594 63 120.6C63 119.606 63.8059 118.8 64.8 118.8C65.7941 118.8 66.6 119.606 66.6 120.6Z"
          fill="#2974C4"
        />
        <path
          d="M73.8 120.6C73.8 121.594 72.9941 122.4 72 122.4C71.0059 122.4 70.2 121.594 70.2 120.6C70.2 119.606 71.0059 118.8 72 118.8C72.9941 118.8 73.8 119.606 73.8 120.6Z"
          fill="#2974C4"
        />
        <path
          d="M79.2 122.4C80.1941 122.4 81 121.594 81 120.6C81 119.606 80.1941 118.8 79.2 118.8C78.2059 118.8 77.4 119.606 77.4 120.6C77.4 121.594 78.2059 122.4 79.2 122.4Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1698_47325">
        <rect width="144" height="144" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Broadcast };
